const hasuraAuthKey =
  process.env.REACT_APP_HASURA_AUTH_KEY ?? 'x-hasura-admin-secret'
const hasuraKey = process.env.REACT_APP_HASURA_KEY
const hasuraRole = process.env.REACT_APP_HASURA_ROLE ?? 'customer'
const hasuraUserKey = process.env.REACT_APP_USER_KEY ?? 'x-hasura-mundi-id'

export default function hasuraHeaders() {
  const userId = localStorage.getItem('userId')
  return {
    [hasuraAuthKey]: hasuraKey,
    [hasuraUserKey]: userId,
    'x-hasura-role': hasuraRole,
  }
}
